import * as ActionTypes from '../ActionTypes';

const initialState = {
    isLoading: false,
    showDetailModal: false,
    zoneList: [],
    limit: '',
    zone: {},
    searchCondition: { recommendOrderFlag: 1, needAreaList: [] },
    pagination: {},
    showMap: false,
    selectZoneIndex: 0,

    showZoneList: [],
    showZonePagination: {},

    selectedZonePhoto: {},
    selectedZonePhotoIndex: -1,
    zoneLessorContactList: [],
    allCounties: [],
    brandList: [],
    districtTownList: [],
    searchFuzzyBampResultList: []

};

const ZoneReducer = (state = initialState, action = 'none') => {
    switch (action.type) {
        case ActionTypes.WMS_ZONE_LIMIT:
            return Object.assign({}, state, {
                limit: action.limit
            });
        case ActionTypes.WMS_ZONE_LOADING:
            return Object.assign({}, state, {
                isLoading: action.isLoading
            });
        case ActionTypes.WMS_ZONE_REFRESH_ZONE:
            return Object.assign({}, state, {
                zone: action.zone
            });
        case ActionTypes.WMS_ZONE_REFRESH_SHOW_MAP:
            return Object.assign({}, state, {
                showMap: action.showMap
            });
        case ActionTypes.WMS_ZONE_REFRESH_SEARCH_CONDITION:
            return Object.assign({}, state, {
                searchCondition: action.searchCondition
            });
        case ActionTypes.WMS_ZONE_LIST:
            return Object.assign({}, state, {
                zoneList: action.zoneList,
                pagination: action.pagination
            });
        case ActionTypes.WMS_ZONE_TOGGLE_DETAIL_MODAL:
            return Object.assign({}, state, {
                showZoneModal: action.showZoneModal
            });
        case ActionTypes.WMS_ZONE_REFRESH_SELECTED_ZONE_PHOTO:
            return Object.assign({}, state, {
                selectedZonePhoto: action.selectedZonePhoto,
                selectedZonePhotoIndex: action.selectedZonePhotoIndex
            });
        case ActionTypes.WMS_ZONE_REFRESH_SELECT_ZONE_INDEX:
            return Object.assign({}, state, {
                selectZoneIndex: action.selectZoneIndex
            });
        case ActionTypes.WMS_ZONE_REFRESH_SELECT_SHOW_ZONE_LIST:
            return Object.assign({}, state, {
                showZoneList: action.showZoneList,
                showZonePagination: action.showZonePagination
            });
        case ActionTypes.WMS_ZONE_LESSOR_CONTACT_LIST:
            return Object.assign({}, state, {
                zoneLessorContactList: action.zoneLessorContactList,
            });
        case ActionTypes.WMS_ZONE_REFRESH_CITY_NAME:
            return Object.assign({}, state, {
                cityName: action.cityName,
            });


        case ActionTypes.WMS_ZONE_MAP_REFRESH_ZONE_LIST:
            return Object.assign({}, state, {
                bMapZoneList: action.bMapZoneList,
                pagination: action.pagination,
            });
        case ActionTypes.WMS_ZONE_MAP_REFRESH_SHOW_POINT_FLAG:
            return Object.assign({}, state, {
                showPointFlag: action.showPointFlag,
            });

        case ActionTypes.WMS_ZONE_MAP_REFRESH_SUMMARY_DISTRICT:
            return Object.assign({}, state, {
                zoneDistrictTotal: action.zoneDistrictTotal,
            });
        case ActionTypes.WMS_ZONE_MAP_REFRESH_SUMMARY_DISTRICT_WITH_CONDITION:
            return Object.assign({}, state, {
                zoneDistrictTotalWithCondition: action.zoneDistrictTotalWithCondition,
            });
        case ActionTypes.WMS_ZONE_MAP_REFRESH_SELECTED_DISTRICT_LIST:
            return Object.assign({}, state, {
                selectedDistrictList: action.selectedDistrictList,
            });
        case ActionTypes.WMS_ZONE_MAP_REFRESH_SELECTED_ZONE_ID:
            return Object.assign({}, state, {
                selectedZoneId: action.selectedZoneId,
            });
        case ActionTypes.WMS_ZONE_REFRESH_ALL_COUNTIES:
            return Object.assign({}, state, {
                allCounties: action.allCounties,
            });
        case ActionTypes.WMS_ZONE_REFRESH_ZONE_COUNT_BY_CONDITION:
            return Object.assign({}, state, {
                zonesCountByCondition: action.zonesCountByCondition,
            });
        case ActionTypes.WMS_ZONE_REFRESH_BRAND_LIST:
            return Object.assign({}, state, {
                brandList: action.brandList,
            });
        case ActionTypes.WMS_ZONE_REFRESH_ALL_TOWN_LIST:
            return Object.assign({}, state, {
                districtTownList: action.districtTownList,
            });
        case ActionTypes.WMS_ZONE_REFRESH_CURRENT_LOCATION:
            return Object.assign({}, state, {
                currentLocation: action.currentLocation,
            });
        case ActionTypes.WMS_ZONE_REFRESH_COORDINATE_MAP:
            return Object.assign({}, state, {
                zoneCoordinateMap: action.zoneCoordinateMap,
            });
        case ActionTypes.WMS_ZONE_LIST_REFRESH_SCROLL_TOP:
            return Object.assign({}, state, {
                listScrollTop: action.listScrollTop,
            });
        case ActionTypes.WMS_ZONE_MAP_REFRESH_CENTER_ZOOM:
            return Object.assign({}, state, {
                mapCenterZoom: action.mapCenterZoom,
            });
        case ActionTypes.WMS_ZONE_SEARCH_FUZZY_BAMP_SEARCH_RESULT:
            return Object.assign({}, state, {
                searchFuzzyBampResultList: action.searchFuzzyBampResultList,
            });

        default:
            return state
    }
};

export default ZoneReducer;